import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie'
import Backbtn from './elements/Backbtn'
import { Footer, Nav, Loader, Analytics } from './elements'

import { spareFetchByBrand } from '../redux/actions'

class Partsdetail extends Component {

    constructor(){
        super()
        this.state = {
            brand_id: "",
            isLogin: false,
            user: ""
        }
    }

    componentWillMount() {
        if(Cookies.get('user')){
            this.setState({
                isLogin: true,
                user: JSON.parse(Cookies.get('user'))
            })
        } else {
            window.location = "/login"
        }
        let params = this.getParams()
        this.props.spareFetchByBrand(params.brand_id)
        this.setState({
            brand_id: params.brand_id,
        })
    }

    getParams() {
        const searchParams = new URLSearchParams(this.props.location.search);
        return {
            brand_id: searchParams.get('brand_id') || '',
        };
    }

    showSpares() {
        if(this.props.spares) {
            return this.props.spares.map((item, index) => {
                return (
                    <div className="each-detail" key={index}>
                        <Analytics />
                        <div className="detail-left">
                            <div className="product-img">
                                <div className="img-wrap">
                                    <img src={item.img} alt="parts"/>
                                </div>
                            </div>
                            {/* <div className="group-btn">
                                <div className="product-catalog">
                                    <a href={"line://oaMessage/@838tngkz/?สั่งซื้อ " + item.name}><button>สั่งซื้อ</button></a>
                                </div>
                            </div> */}
                        </div>
                        <div className="detail-right">
                            <h2 className="product-title">{item.name}</h2>
                            {(item.price && <h4>ราคา : <span className="price">{item.price}</span> บาท</h4>)}
                            {(item.brand && <p>ยี่ห้อ : <span className="brand">{item.brand}</span></p>)}
                            {(item.description && <p>รายละเอียด : <span className="detail">{item.description}</span></p>)}
                        </div>
                        <div className="group-btn">
                            <div className="product-catalog">
                                <a href={"line://oaMessage/@838tngkz/?สั่งซื้อ " + item.name}><button>สั่งซื้อ</button></a>
                            </div>
                        </div>
                    </div>
                )
            })
        } else {
            return <Loader />
        }
    }

    render() { 
        if(!this.state.isLogin) return <div></div>
        return ( 
            <div className="page-partsdetail">
                <div className="partsdetail-header">
                    <Backbtn backSearch={this.state.backSearch}/>
                    <div className="title">
                        <p>{this.props.spares && this.props.spares[0].brand_title}</p>
                        {/* <p className="air-type">{this.state.type}</p> */}
                    </div>
                    <Nav />
                </div>
                <div className="partsdetail-detail container">
                    {this.showSpares()}
                </div>
                <Footer />
            </div>
        )
    }
}
 
const mapStateToProps = ({ spare }) => {
    return { 
        spares: spare.spares
    }
}
 
export default connect(mapStateToProps, { spareFetchByBrand })(Partsdetail)